// ---- App-wide constants ----
// Edit these to change statuses, salary bands, or reminder thresholds.

const STORAGE_KEY   = 'jobTracker.v1';
const STALE_DAYS    = 7;   // days before a waiting job is flagged as stale
const FOLLOWUP_DAYS = 10;  // days before a contact gets a follow-up nudge
const FREE_JOB_LIMIT = 50; // maximum jobs stored by a Free account
const MAX_CSV_FILE_BYTES = 1024 * 1024; // 1 MB
const MAX_CSV_IMPORT_ROWS = 1000;
const JOB_FETCH_PAGE_SIZE = 1000; // Supabase API may cap a single response at 1,000 rows

const STATUSES = [
  { id: 'applied',   label: 'Applied',   cls: 'chip-waiting' },
  { id: 'interview', label: 'Interview', cls: 'chip-interview' },
  { id: 'yes',       label: 'Offer',     cls: 'chip-yes' },
  { id: 'ghosted',   label: 'Ghosted',   cls: 'chip-ghosted' },
  { id: 'no',        label: 'Rejected',  cls: 'chip-no' },
];

const STATUS_MAP = Object.fromEntries(STATUSES.map(s => [s.id, s]));
// Keep 'waiting' entries so old saved data still sorts/displays correctly until migrated.
const STATUS_SORT_ORDER = {
  yes: 0,
  offer: 0,
  interview: 1,
  applied: 2,
  waiting: 2,
  no: 3,
  rejected: 3,
  ghosted: 4,
};

const SALARY_BANDS = ['$100 - $130', '$130 - $150', '$150 - $200', '$200+'];

const SORT_OPTIONS = [
  { value: 'title-asc', label: 'Job Title' },
  { value: 'date-asc', label: 'Date Applied - Ascending' },
  { value: 'date-desc', label: 'Date Applied - Descending' },
  { value: 'status-asc', label: 'Status' },
  { value: 'salary-asc', label: 'Salary - Ascending' },
  { value: 'salary-desc', label: 'Salary - Descending' },
];
